import React from "react";
import { Card } from "@UI/Components/Card/Card";
import { ServiceOfferDescriptionProps } from "./types";
import { LoadingScreen } from "@UI/Components/LoadingScreen/LoadingScreen";
import { ServiceOfferItem } from "../../../Purchasing/Components/OrderDescription/OrderDescriptionItems/ServiceOfferItem";
import { ServiceFees } from "../../../Purchasing/Components/OrderDescription/OrderDescriptionItems/ServiceFees";
import { List } from "@UI/Components/List/List";
import { TotalServiceOffer } from "./TotalServiceOffer";
import { useServiceOffer } from "@modules/ServiceAssignment/hooks/useServiceOffer";
import { AdvancePaymentItem } from "./AdvancePaymentItem";

// The showServiceFees and showAdvancePayment props are used for the serviceOffer Modal.
// In that step(When the SP has made an offer, we don't want to show the fees or advance payment yet)
export const ServiceOfferDescription = ({
  serviceOfferId,
  showServiceFees = true,
  showAdvancePayment = true,
  colorScheme,
  ...props
}: ServiceOfferDescriptionProps) => {
  const { serviceOffer, totalExpensesFees, isLoading, totalExpenses } =
    useServiceOffer(serviceOfferId);

  if (isLoading) {
    return <LoadingScreen />;
  }

  const {
    rateCents,
    rateCurrency,
    billingCount,
    billingUnit,
    expenses,
    fees,
    prepaidCents,
  } = serviceOffer;

  return (
    <Card
      background={colorScheme === "sand" ? "sand.100" : "transparent"}
      shadow="none"
      padding={0}
      {...props}
    >
      <List>
        <ServiceOfferItem
          preview
          priceCents={rateCents}
          currency={rateCurrency}
          billingCount={billingCount}
          billingUnit={billingUnit}
          expenses={expenses}
          totalExpenses={totalExpenses}
          serviceProviderId={serviceOffer?.serviceProvider?.id}
        />
        {showServiceFees && (
          <ServiceFees
            preview
            itemFeesCents={fees?.[0]?.amountCents}
            serviceFeeRate={fees?.[0]?.details?.percentage}
            billingUnit={billingUnit}
            billingCount={billingCount}
            currency={fees?.[0]?.amountCurrency}
            totalExpensesFees={totalExpensesFees}
          />
        )}
        {showAdvancePayment && (
          <AdvancePaymentItem prepaidCents={prepaidCents} />
        )}
        <TotalServiceOffer
          serviceOfferId={serviceOfferId}
          colorScheme={colorScheme}
          includeFees={showServiceFees}
          includeAdvancePayment={showAdvancePayment}
          preview
        />
      </List>
    </Card>
  );
};
